export const styles = {
	ideaCheckbox: {
		color: '#6A6A6A !important',
		'&.Mui-checked': {
			color: '#6A6A6A !important',
		},
	},
	actionIcon: {
		color: 'primary.dark',
	},
	basicChip: { color: '#000000', bgcolor: '#EBEBEB' },
	ideaRowHeader: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '1rem',
		'@media (max-width: 600px)': {
			gap: 0,
		},
	},
	ideaRowMetadataPills: {
		display: 'inline-flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '2rem',
	},
	prototypeButton: {
		marginLeft: 'auto',
	},
}
